import getFinanceTypes from '../finance-product-objects/get-finance-types';
import Swal from 'sweetalert2';
import SearchResultsVehicle from './search-results-vehicle';

window.$ = window.jQuery = require('jquery');

/**
 * Class to render the output of a CW finance response
 * Specifically designed for the model index (trim level) page
 */
export default class extends SearchResultsVehicle {
    constructor(target) {
        super(target);
        this.products_name = 'PCP';
        this.financeTypes = getFinanceTypes(this);
        return;
    }

    setLoading() {
        this.jqueryTarget.html('<img src="/images/shared/Robins-And-Day-Loader.svg" class="trim-box-finance-area-loading" alt="Loading Monthly Payment" />').show();
    }

    outputQuotesOnResults() {
        if (this.quoteToShow === false) {
            this.target.classList.add('trim-box-finance-area--no-finance');
            this.target.innerHTML = '<span class="price">&nbsp;</span>No finance available';
        } else if (this.quoteToShow.errors) {
            this.target.classList.add('trim-box-finance-area--no-finance');
            this.target.innerHTML = `<span class="cms-content-trim-level__finance--error">Unable to quote</span><span class="cms-content-trim-level__finance--error">${this.quoteToShow.errors.join('<br />')}</span>`;
        } else {
            this.target.classList.remove('trim-box-finance-area--no-finance');
            const link = this.link + this.getQueryStringForFinanceProduct(this.quoteToShow);

            const repLink = document.createElement('a');
            if (getCookieValue('new_finance_modified') == 'Y') {
                repLink.innerText = 'View personal quote';
            } else {
                repLink.innerText = 'View representative example';
            }


            repLink.dataset.tag = "Trim Page Link";
            repLink.dataset.action = "From text";
            repLink.dataset.label = "Clicked";
            repLink.classList.add('trim-box-rep-example-link');
            repLink.classList.add('cms-content-trim-level__representative-link');
            repLink.addEventListener('click', (event) => {this.showRepresentativeExample(this.codeweaversResponse, this.quoteToShow)});

            let html = `<div class="cms-content-trim-level__flex-row cms-content-trim-level__flex-row--with-border"><p>Per Month from</p><a href="${link}"><span class="cms-content-price cms-content-price--blue">&pound;${number_format(this.quoteToShow.getMonthlyPayment(), 0)}</span></a></div>`;

            const apr = this.quoteToShow.getApr();
            if (apr !== false) {
                if (document.body.classList.contains('variant')) {
                    html += `<a class="cms-content-trim-level__apr-text" data-action="APR" data-label="Clicked" href="${link}#personalise-finance"><span class="cms-content-price cms-content-price--blue">${apr}% APR</span> Representative </a>`;
                } else {
                    html += `<p class="cms-content-trim-level__apr-text trim-box-apr" data-tag="Trim Page Link" data-action="APR" data-label="Clicked"><span class="cms-content-price cms-content-price--blue">${apr}% APR</span> Representative</p>`;
                }
            }
            this.target.innerHTML = html;
            this.target.appendChild(repLink);
        }
        this.jqueryTarget.show();
    }

    showRepresentativeExample(codeweaversResponse, financeProduct) {
        this.financeTypes.forEach(financeKeyObject => {
            // If we're not showing all products, and the product doesn't match this finance key object, then skip this finance key object, we don't want it
            if (financeKeyObject.pseudoKey.toLowerCase() !== financeProduct.getKey().toLowerCase()) {
                return;
            }
            codeweaversResponse.financeKeyObject = financeKeyObject;
        });

        Swal.fire({
            title: 'Representative Example',
            html: `<div class="trim-box-representative-example">${codeweaversResponse.financeKeyObject.render(codeweaversResponse)}</div><div class="trim-box-representative-example-terms"><p class="terms cms-content-trim-level__representative-example-terms">${codeweaversResponse.financeKeyObject.getTermsAndConditions(codeweaversResponse)}</p></div>`,
            showCloseButton: false,
            showConfirmButton: false,
            showCancelButton: true,
            buttonsStyling: false,
            width: '530px',
            customClass: {
                popup: 'cms-content-trim-level__modal-card',
                cancelButton: 'btn btn--primary',
                title: 'cms-content-trim-level__modal-title',
                container: 'cms-content-trim-level__modal-container'
            },
            cancelButtonText: "Close",    
        });
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/new-car-pages/modules/finance/vehicle-objects/model-index-vehicle.js